import EditImages from "./editImages";

export default EditImages;
